import styled, { css } from 'styled-components';
import { getDefaultValue, globalTheme } from '@clds/component-theme';
import { Code } from './components/Code';
import { CodeSnippetProps, SimpleSnippet } from './types';
import { t } from './CodeSnippetTheme';

// height: undefined   -> don't set any min/max height, container will fit the currently displayed code
// height: <number>    -> set exact height expressed in rows count
// height: 'XXpx'      -> set exact height expressed in pixels

const getHeight = (height: number | string) => (typeof height === 'string' ? height : getHeightByRowsCount(height));
const getHeightByRowsCount = (rows: number) => `calc(${rows} * ${getDefaultValue(t.code.lineHeight)} + 2 * ${getDefaultValue(t.code.padding)})`;

export const StyledCode = styled(Code)<CodeSnippetProps<SimpleSnippet>>`
  margin-top: ${globalTheme.spacing.xs};

  pre {
    ${(props) => (props.height ? `min-height: ${getHeight(props.height)};` : '')};
    ${(props) => (props.height ? `max-height: ${getHeight(props.height)};` : '')};
    height: 100%;
  }
`;

export const HorizontalToolbar = styled.div`
  display: flex;
  align-items: center;
`;

export const ellipsisWidth = css`
  max-width: calc(100% - 50px);
`;

export const StyledEllipsisText = styled.div`
  max-width: 55px;
  text-overflow: ellipsis;
  overflow: hidden;
  direction: rtl;
  text-align: left;
`;
